import { t } from "@lingui/macro";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: hsl(0, 0%, 100%);
  z-index: 1;
  position: fixed;
  top: 0;
  background-color: #2a2f39;
  padding: 16px;
  width: 100%;
`;

const Header = styled.div`
  font-family: CamptonSemiBold, sans-serif;
`;

const ReloadLink = styled.a`
  background: #9a39fb;
  color: #ffffff;
  padding: 10px;
  margin-left: 10px;
  border-radius: 3px;
`;

const FallbackError = () => {
  return (
    <Container>
      <div>
        <Header> An exception occurred while rendering the map.</Header>
        If the issue remains please contact <a href="mailto:info@gsmtasks.com">info@gsmtasks.com</a> for support.
      </div>
      <ReloadLink href={window.location.href}>Refresh Page</ReloadLink>
    </Container>
  );
};

export default FallbackError;
